module.exports = __webpack_public_path__ + "static/media/yes.8c12d33b.png";